import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ControlItem, ProductTypesEnum } from 'src/app/models/frontend';
import { DiscountTemplatesService } from '../discount-templates.service';
import Swal from 'sweetalert2';
import { IPagedGeneralDiscountTemplateResultRequestDto } from 'src/app/models/backend';
import { ToastrService } from 'ngx-toastr';

interface EditGeneralDiscount {
  id: number
  productType: string;
  discountPercentage: number
  discountTemplateId: number
  discountTemplateName: string
}

@Component({
  selector: 'app-edit-general-discount-template',
  templateUrl: './edit-general-discount-template.component.html',
  styleUrls: ['./edit-general-discount-template.component.scss']
})

export class EditGeneralDiscountTemplateComponent {
  productType: ControlItem[] = []
  ID: any
  generalCategory: any = []
  eventForm: FormGroup
  modelData: EditGeneralDiscount;

  DomesticTopUp: number = 10;
  International: number;
  PridExpress: number;
  Health: number

  requestGeneral: IPagedGeneralDiscountTemplateResultRequestDto = {
    isInvoledDeletedItems: false,
    skipCount: 0,
    maxResultCount: 10,
    discountTemplateId: 0
  }
  Role:any
  constructor(public activatedRoute: ActivatedRoute,
    public discountService: DiscountTemplatesService,
    public router:Router,private toastr:ToastrService
  ) {
    this.productType = ProductTypesEnum
   
    this.activatedRoute.params.subscribe(params => { this.ID = params['id'].replace('id', '') });
    this.Role=localStorage.getItem("RoleType")
  }
  ngOnInit() {
    this.LoadData();
  }
  LoadData() {
    this.requestGeneral = {
      isInvoledDeletedItems: false,
      skipCount: 0,
      maxResultCount: 10,
      discountTemplateId: this.ID
    }
    this.discountService.GetDiscountTemplateGenerals(this.requestGeneral).subscribe((res: any) => {

      this.modelData = res.items
      console.log(this.modelData)
      for (let i = 0; i < res.totalCount; i++) {
        if (this.modelData[i].productType === 1) {
          this.DomesticTopUp = this.modelData[i].discountPercentage;
        }
        else if (this.modelData[i].productType === 2) {
          this.International = this.modelData[i].discountPercentage;
        }
        else if (this.modelData[i].productType === 3) {
          this.PridExpress = this.modelData[i].discountPercentage;
        }
        else if (this.modelData[i].productType === 4) {
          this.Health = this.modelData[i].discountPercentage;
        }
      }
    })
  }

  Submit() {

    for (let i = 0; i < 4; i++) {
      if (this.modelData[i].productType === 1) {
        this.generalCategory.push({ productType: 1, discountPercentage: this.DomesticTopUp, discountTemplateId: this.ID ,id:this.modelData[i].id})
      }
      else if (this.modelData[i].productType === 2) {
        this.generalCategory.push({ productType: 2, discountPercentage: this.International, discountTemplateId: this.ID ,id:this.modelData[i].id})
      }
      else if (this.modelData[i].productType === 3) {
        this.generalCategory.push({ productType: 3, discountPercentage: this.PridExpress, discountTemplateId: this.ID ,id:this.modelData[i].id})
      }
      else if (this.modelData[i].productType === 4) {
        this.generalCategory.push({ productType: 4, discountPercentage: this.Health, discountTemplateId: this.ID ,id:this.modelData[i].id})
      }
    }
    console.log(this.generalCategory.length)
    for (let i = 0; i < 4; i++) {
      this.discountService.UpdateDiscountTemplateGeneral(this.generalCategory[i]).subscribe((res: any) => {
        if(i=3){
          // Swal.fire('Updated', '', 'success')
          this.toastr.success('Updated','Success')
          this.router.navigateByUrl("discount-templates");
        }
      })
      
    }
    
  }

  Cancel(){
    this.router.navigateByUrl("discount-templates");
  }
}
